import { Component, OnInit, ViewChild } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import 'rxjs/add/operator/switchMap';
import {Location} from '@angular/common';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { ValidatorService } from '../../../services/tools/validator.service';
import { SuccessModalComponent } from '../../../components/tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../../../components/tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../../../components/tools/modals/confirm-modal/confirm-modal.component';
import { Globals } from '../../../services/tools/Globals.service';
import { CreditosHipotecariosService } from "../../../services/creditos-hipotecarios.service";
import { ClientesService } from "../../../services/clientes.service";
import { PrestamosService } from "../../../services/prestamos.service";
import { PlazosService } from "../../../services/plazos.service";
import { CreditosService } from "../../../services/creditos.service";
import { ConveniosService } from '../../../services/convenios.service';


declare var $;

@Component({
  selector: 'app-creditos-hipotecario-simulacion',
  templateUrl: './creditos-hipotecario-simulacion.component.html',
  styleUrls: ['./creditos-hipotecario-simulacion.component.scss']
})
export class CreditosHipotecarioSimulacionComponent implements OnInit {

  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
  //Constants
  private tipoCredito = 1;
  //UI
  creditos : any = {};
  cliente : any = {};
  plazos : any = [];
  prestamos : any = {};
  plazosSelected : any = {};
  calculado : boolean = false;
  procesandoCalculo : boolean = false;
  maximoPrestamo : any = 0;
  selectedLoan : number = 0;
  loanType : string = '';
  customMaxLoan : any = '';
  catalogoPeriodicidad: object = {};
  catalogoTipoCalculo: object = {};
  indexSelected : any = 0;
  errors:any = {};
  processing:any = false;
  //Edite mode
  private sub: any;
  private id : number = 0;
  credito : object = {};

  price : number = 0;

  //Selección de convenio
  public convenioDefault = "";
  public convenioSelected:any = {id:null};
  public optConvenios = []

  constructor
  (
    private Service: CreditosHipotecariosService, 
    private clientesService: ClientesService,
    private prestamosService: PrestamosService,
    private plazosService: PlazosService,
    private validatorService: ValidatorService, 
    private helperService: HelpersService,
    private globals: Globals,
    private router: Router,
    private creditosService: CreditosService,
    private activeRoute: ActivatedRoute,
    private location : Location,
    private conveniosService : ConveniosService,
    
  )
  {
    this.resetSelected = this.resetSelected.bind(this);
   }

  public ngOnInit() {
    this.getConvenios();
    this.sub = this.activeRoute.params.subscribe(params => {
      this.getPlazos();
      if(params['id']){
        this.id = params['id'] ? +params['id'] : 0; // (+) converts string 'id' to a number
        //Edit a credit
        //TODO: La funcion getCreditos depende que haya regresado la funcion GetPlazos (chaining)
        this.getCredito(this.id);
      }else{
        //Create a new credito
        this.startSelected();
      }      
    });
  }

  //TODO: Investigar si estas inicializaciones son necesarias o se pueden aplicar en la definición de los atributos
  resetSelected(){
    this.cliente = {};
    this.plazos = [];
    this.creditos = {};
    this.prestamos = {};
    this.errors = {};
    this.plazosSelected = {};
  }

  //TODO: Investigar si estas inicializaciones son necesarias o se pueden aplicar en la definición de los atributos
  startSelected(){
    this.resetSelected();
    this.plazos = this.plazosService.getDefaultScheduleArray();
    this.plazosSelected = this.plazosService.getDefaultSchedule();
    this.creditos = this.Service.getDefaultSchedule();

    //Set default values for loan
    this.prestamos = this.prestamosService.getDefaultSchedule();
    this.setDefaultValues();  
  }

  public getConvenios(){
    // let filters = this.getActiveFilters();

    this.conveniosService.getAll({tipo:"Hipotecario"}).subscribe(
      (response)=>
      {
        let respuesta = response.json().content;
        console.log(respuesta);
        if (respuesta.length > 1){
          this.optConvenios = respuesta;
          this.convenioDefault = "Sin convenio";
        }else{
          this.optConvenios = respuesta;
          this.convenioDefault = "Sin convenio";
          this.prestamos.idConvenio = null;
          // this.convenioDefault = ""
          // this.convenioSelected = this.optConvenios[0]
          // this.prestamos.convenio = this.convenioSelected.id;
        }
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  convenioChanged(tipo){
    console.log("Event convenio: ", tipo);
    
    if(tipo.id){
        this.convenioSelected = tipo;
        // this.convenio.tipo_convenio = this.tipoSelected.nombre;
        console.log("Tipo convenio: ",this.prestamos);
        this.prestamos.calculo = this.convenioSelected.calculo;
        this.prestamos.periodicidad = this.convenioSelected.periodicidad;
        this.prestamos.convenio = this.convenioSelected.id;
    }else{
      this.setDefaultValues();
    }
  }
    private selectConvenio(idConvenio: number | string) {
    if (!idConvenio || !this.optConvenios) {
      this.convenioSelected = null;
      return;
    }

    // 1. Find the object. Using == instead of === handles string/number mismatches safely.
    const convenioEncontrado = this.optConvenios.find(c => c.id == idConvenio);

    if (convenioEncontrado) {
      // 2. Assigning the reference for UI binding
      this.convenioSelected = convenioEncontrado;
    } else {
      this.convenioSelected = null;
      // Log for debugging if a loan has a convenio ID that doesn't exist in the catalog
      console.warn(`Convenio with ID ${idConvenio} not found in catalog.`);
    }
  }

  setDefaultValues(){
    this.prestamos.calculo = 1;//Calculo insoluto
    this.prestamos.periodicidad = 2;//Periodicidad Mensual
    this.catalogoPeriodicidad = this.creditosService.getCatalogoPeriodicidad();
    this.catalogoTipoCalculo = this.creditosService.getCatalogoTipoCalculo();
  }

  changePlazosSelected(plazos){
    this.plazosSelected = plazos;
    this.prestamos.idCatalogos_Plazos = this.plazosSelected.id;
    this.prestamos.plazo_periodo = plazos.periodo;
    this.prestamos.plazo_medida = plazos.medida;
  }
  
  getPlazos(){
    this.plazosService.getAll(this.tipoCredito).subscribe(
      (response)=>
      {
        this.plazos = response.json().content;
      }, error =>
      {
        this.processing = false;

        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  calcularCapacidad()
  {
    this.errors = [];
    this.errors = this.Service.validateCapacidad(this.creditos);

    if (!$.isEmptyObject(this.errors)) {
      this.creditos.capacidad_pago = '';
      return false;
    }
    
    this.creditos.capacidad_pago = ((Number(this.creditos.promedio_mensual) * .35) 
    - Number(this.creditos.buro_mensual));

    if(this.creditos.capacidad_pago <= 0){
      this.errors = [];
      this.errors['capacidad'] = 'La capacidad de pago libre debe ser mayor a 0';
      //Aunque el valor sea menor a 0 debemos mostra 0 ya que no hay capacidad de pago libre
      this.creditos.capacidad_pago = 0;
    }
  }

  onLoanTypeSelected(loanType:string){

    switch(loanType){
      case 'maxAllowed':
        this.selectedLoan = parseFloat(this.maximoPrestamo);
        break;
      case 'custom':
          if(this.customMaxLoan !== ''){
            this.selectedLoan = parseFloat(this.customMaxLoan);
          }
          else{
            //Si no se ha ingresado el valor del prestamo, su valor default debe ser igual a 0
            this.selectedLoan = 0;
          }
          break
      default:
        //Este caso es para cuadno se reinicia los valores de el crédito seleccionado por ello es que no se valida el prestamos
        this.selectedLoan = 0;
        break;
    }
  }

  enterSelectedLoan()
  {
    //Si se ingresa un valor en el campo del préstamo máximo, se selecciona que el tipo de préstamo es custom (personalizado)
    if(this.loanType !== 'custom'){
      this.loanType = 'custom';
    }
    this.onLoanTypeSelected( 'custom'); 

  }

  calcular(montoPrestamo:number = 0)
  {
    this.procesandoCalculo = true;
    this.errors = [];
    this.errors = this.Service.validateCalcularCapacidad(this.creditos, this.prestamos);
    
    if (!$.isEmptyObject(this.errors)) {
      this.procesandoCalculo = false;
      return false;
    }
    
    //Desseleccionar el tipo de monto máximo. Se necesita cambiar su valor para que haga el uncheck
    this.loanType = this.loanType ? '' : 'false' ;
    //Como se recalculo el monto máximo del crédito, se debe reiniciar el valor seleccionado del prestamo
    this.customMaxLoan = '';
    this.onLoanTypeSelected(this.loanType);

    //TODO: Utilizar el valor de los plazos y no el id del catalogo
    this.Service.getCapacidadPago(this.prestamos.tasa, Number(this.creditos.capacidad_pago), this.prestamos.plazo_periodo, this.prestamos.plazo_medida, this.prestamos.periodicidad).subscribe(
      (response)=>
      {
        this.maximoPrestamo = Number(response.json().content.monto);
        this.procesandoCalculo = false;
        this.calculado = true;
        if(montoPrestamo && montoPrestamo > 0){
          this.customMaxLoan =  Number(montoPrestamo).toFixed(2);
          this.loanType = 'custom';
          this.onLoanTypeSelected(this.loanType);
        }
      }, error =>
      {
        this.processing = false;

        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
        this.procesandoCalculo = false;
        this.calculado = false;
      }
    );
  }

  /*
  Show Preview
  */
  showPreview(){

    //Validar los datos generales del crédito
    let capacidadErrors = this.Service.validateCalcularCapacidad(this.creditos, this.prestamos);
    //Validar el monto del crédito seleccionado    
    let selectedCreditoErrors = this.Service.validateCreditoSeleccionado(this.selectedLoan, this.maximoPrestamo);
    //Validar la información del cliente
    let clienteErrors = this.Service.validateClient(this.cliente);
    

    //Join the validation errors
    
    const validationErrors = [];

    Object.keys(capacidadErrors)
      .forEach(key => validationErrors[key] = capacidadErrors[key]);

    Object.keys(selectedCreditoErrors)
      .forEach(key => validationErrors[key] = selectedCreditoErrors[key]);

    Object.keys(clienteErrors)
    .forEach(key => validationErrors[key] = clienteErrors[key]);
    console.log('validationErrors', validationErrors);
    this.errors = validationErrors;

    if ($.isEmptyObject(this.errors)){
      //Save the credit data and navigate to the amortizacion table
      this.saveCredit();
    }

    
  }

  saveCredit(){
    this.creditos.idConvenio = this.prestamos.convenio
    //Validar que no se haya convertido en un valor numerico el campo capacidad de pago
    if(isNaN(this.creditos.capacidad_pago)){
      this.creditos.capacidad_pago = parseFloat(this.creditos.capacidad_pago);
    }

    //Convertir en numerico el valor de la tasa
    if(isNaN(this.prestamos.tasa)){
      this.prestamos.tasa = parseFloat(this.prestamos.tasa);
    } 
    
    this.prestamos.monto_prestamo = this.selectedLoan;

    this.errors = {};
        
        let credito = {
          idCreditos : null,
          hipotecario: this.creditos,
          prestamo : this.prestamos,
          cliente : null
        };

        if(typeof this.cliente.email === 'object'){
          //Cuando se selecciono un usuario con Typeahead, 
          //el modelo cliente.email tiene asociado un objeto con todos los datos del cliente
          let clienteToSave = {
            email : this.cliente.email.email,
            nombre : this.cliente.nombre,
            //Cuando es un update el modelo this.cliente tiene todos los datos del cliente
            //En el caso del create en el modelo this.cliente.email Typeahead pone el JSON completo del Cliente
            id : (this.cliente.id ? this.cliente.id : this.cliente.email.id)
          };
          credito.cliente = clienteToSave;
        }else{
          //Caso cuando el email se ingreso de forma manual
          credito.cliente = this.cliente;
        }

    if(this.id > 0){
      credito.idCreditos = this.id;
      this.updateCredito(credito);
    }else{
      this.createNewCredito(credito);
    }
      
  }

  private createNewCredito(credito: any){
    this.Service.save(credito)
      .subscribe(response => {
        this.processing = false;
        if (response.json().success) {
          const creditId = response.json().content.id
          this.router.navigate(['/creditos/tabla-amortizacion/', creditId]);
        }
      }, error => {
        this.processing = false;

          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);

          if(error.status == 400) {
            this.showSaveCreditErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
      });
  }

  private updateCredito(credito: any){
    this.Service.update(credito)
      .subscribe(response => {
        this.processing = false;
        if (response.json().success) {
          const creditId = response.json().content.id
          this.router.navigate(['/creditos/tabla-amortizacion/', creditId]);
        }
      }, error => {
        this.processing = false;

          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);

          if(error.status == 400) {
            this.showSaveCreditErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
      });
  }

  showSaveCreditErrors(errors){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors.push()

      //TODO: Agregar el mapeo de todos los posibles errores en el backend
      switch(key){
        case 'cliente.email':
            temp_errors['email'] = errors[key][0];
          break;
        case 'customMaxLoan':
            temp_errors['customMaxLoan'] = errors[key][0];
          break;
      }
    });

    this.errors = temp_errors;
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  writePermission() {
    return this.Service.writePermission();
  }

  /**
   * Edite mode fucntions
   */

  getCredito(idCredito: number){

    let credito = { prestamo : null };
    this.creditosService.get(idCredito).switchMap(
      data => {
        // do something with your data
        credito = data.json().content;
        return this.Service.getCreditoHipotecario(idCredito); // use it for example in your http request
      }
    ).subscribe(
      hipotecarioData => {
        console.log("Datos recibidos de la BD credito", credito);
        console.log("Datos recibidos de la BD hipotecario:", hipotecarioData.json().content);
        //const credito = response.json().content;
        //Handle credito data
        this.credito = credito;
       
        this.fillCreditoData(credito);

        //Handle hipotecario data
        const arrayCreditosHipotecario = hipotecarioData.json().content;
        if(arrayCreditosHipotecario.length > 0){
          const hipotecario = arrayCreditosHipotecario[0];
          this.fillCreditoHipotecarioData(hipotecario);      
        }
        
        //Final setup
        //TODO: Estas funciones se deberían ejecutar después de traer la info de todos los serivicios
        this.setDefaultValues();
        this.calcular(credito.prestamo.monto_prestamo);
        this.selectConvenio(credito.prestamo.idConvenio);
        this.prestamos= credito.prestamo;
        
      }
      , error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);

          if(error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }  
    );

  }
  public goBack(){
    this.location.back();
  }

  /**
   * Helpers
   */

  fillCreditoHipotecarioData(creditoHipotecario){
    //Por la mascara que aplica el input, hay que formatear los valores para que siempre tengan dos decimales
    //TODO: Mejorar el componente del input para que no sea necesario hacer este 'hack'
    this.creditos.promedio_mensual = Number(creditoHipotecario.promedio_mensual).toFixed(2);
    this.creditos.buro_mensual = Number(creditoHipotecario.buro_mensual).toFixed(2);
    this.creditos.buro_mensual = Number(creditoHipotecario.buro_mensual).toFixed(2);
    this.creditos.capacidad_pago = Number(creditoHipotecario.capacidad_pago).toFixed(2);
    this.price = Number(creditoHipotecario.promedio_mensual);
    this.creditos.id = creditoHipotecario.id;
  }

  private fillCreditoData(credito: any){
    //Por la mascara que aplica el input, hay que formatear los valores para que siempre tengan dos decimales
    //TODO: Mejorar el componente del input para que no sea necesario hacer este 'hack'
    this.prestamos.tasa = Number(credito.prestamo.tasa).toFixed(2);
    this.prestamos.id = credito.prestamo.id;
    const plazo_periodo = credito.prestamo.plazo_periodo;
    const plazo_medida = credito.prestamo.plazo_medida;
    let selectedPlazo = 0; 
    this.plazos.forEach(function(element) {
      
      if(plazo_periodo === element.periodo && plazo_medida === element.medida){
        selectedPlazo = element;
      }
    });

    this.cliente = credito.cliente;
    
    if(selectedPlazo){
      this.changePlazosSelected(selectedPlazo);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/creditos/hipotecario/simulacion/creditos-hipotecario-simulacion.component.ts